import { useLocation, useNavigate } from "react-router"
import { useAuth } from "../../utility/useAuth"
import { useEffect, useState } from "react"
import { cookie } from "../../common/cookie"

export const Login: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useAuth()
    const [userIsLoggedIn, setUserIsLoggedIn] = useState(false)
  
    const urlQuery = window.location.search
    const redirectUrl = new URLSearchParams(urlQuery).get('redirectUrl')
  
    useEffect(() => {
      auth.getUser().then((user) => {
        setUserIsLoggedIn(!!user)
      })
    }, []) // eslint-disable-line
  
    //if (userIsLoggedIn) navigate('/home')
    if (userIsLoggedIn) {
      const from = location.state?.from?.pathname || '/'; // Get previous path or default to '/'
      console.log(`from: ${from}`);
      navigate(from, { replace: true });
    }
  
    auth.login().then(() => {
      if (redirectUrl) cookie.set('redirectUrl', redirectUrl)
    })
  
    return <>Loading...</>//<LoadingTemplate />
  }